import React, { useEffect, useState } from 'react';
import {
  FaArrowRight, FaBars, FaChartLine, FaCheck, FaCheckCircle,
  FaClipboardCheck, FaCloudSun, FaEnvelope, FaFileAlt, FaLock,
  FaMapMarkedAlt, FaMicrochip, FaMobileAlt, FaRocket, FaSatellite,
  FaSeedling, FaShieldAlt, FaTimes, FaTint, FaUsers,
} from 'react-icons/fa';
import {
  PAYMENT_CATALOG, TRIAL_PLAN, formatCurrency, getAnnualSavings,
} from '../config/paymentCatalog';
import './LandingPage.css';

const CONTACT_EMAIL = 'climorax.app@gmail.com';

const productModules = [
  { icon: FaMapMarkedAlt, title: 'Central de Operações', description: 'Desenhe propriedades e talhões no mapa, calcule áreas e conduza a operação a partir de cada polígono.', tag: 'Gestão territorial' },
  { icon: FaClipboardCheck, title: 'Caderno de Campo', description: 'Crie ordens de serviço, atribua responsáveis, registre despesas, evidências e o histórico de execução.', tag: 'Rastreabilidade' },
  { icon: FaCloudSun, title: 'Clima e riscos', description: 'Consulte previsão, histórico climático, condições do talhão e alertas que apoiam a decisão no campo.', tag: 'Decisão agronômica' },
  { icon: FaMicrochip, title: 'Sensores de campo', description: 'Acompanhe estações meteorológicas e sensores georreferenciados com leituras e gráficos operacionais.', tag: 'Telemetria' },
  { icon: FaTint, title: 'Manejo de irrigação', description: 'Organize estações, setores e recomendações de manejo com contexto de propriedade e talhão.', tag: 'Manejo hídrico' },
  { icon: FaChartLine, title: 'Desempenho da safra', description: 'Reúna metas, custos e indicadores produtivos para acompanhar a evolução da operação agrícola.', tag: 'Gestão' },
];

const journey = [
  { number: '01', title: 'Mapeie a operação', description: 'Localize a fazenda, desenhe a propriedade e organize os talhões com área calculada pelo mapa.' },
  { number: '02', title: 'Conecte campo e equipe', description: 'Associe plantios, sensores, ordens, despesas e responsáveis ao lugar onde o trabalho acontece.' },
  { number: '03', title: 'Decida com contexto', description: 'Acompanhe clima, alertas, imagens e resultados em uma visão única, segura e rastreável.' },
];

const trustItems = [
  { icon: FaShieldAlt, title: 'Dados separados por conta', text: 'Cada operação acessa somente as informações permitidas para seus usuários.' },
  { icon: FaUsers, title: 'Acesso por equipe', text: 'Organize responsáveis, convidados e permissões conforme o plano contratado.' },
  { icon: FaMobileAlt, title: 'Web responsiva', text: 'Use no computador, tablet, iPhone ou Android, direto pelo navegador.' },
  { icon: FaFileAlt, title: 'Histórico preservado', text: 'Registros de campo, anexos e cultivos permanecem vinculados ao local correto.' },
];

function scrollToSection(id) {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function ProductPreview() {
  return (
    <div className="landing-product-preview" aria-label="Prévia da Central de Operações do ClimoraX">
      <div className="landing-preview-topbar">
        <div className="landing-preview-window"><i /><i /><i /></div>
        <div className="landing-preview-title"><FaSatellite /> Central de Operações</div>
        <span className="landing-preview-live"><i /> Operação conectada</span>
      </div>
      <div className="landing-preview-body">
        <aside className="landing-preview-sidebar" aria-hidden="true">
          <span className="is-brand">CX</span>
          {[FaMapMarkedAlt, FaClipboardCheck, FaCloudSun, FaMicrochip, FaTint].map((Icon, index) => (
            <span key={index} className={index === 0 ? 'is-active' : ''}><Icon /></span>
          ))}
        </aside>
        <div className="landing-preview-map">
          <div className="landing-map-search">Buscar propriedade, talhão ou cidade <span>Localizar</span></div>
          <div className="landing-map-status"><i /> Fazenda Boa Vista</div>
          <svg className="landing-map-polygons" viewBox="0 0 740 470" role="img" aria-label="Propriedade e talhões desenhados sobre o mapa">
            <defs>
              <linearGradient id="propertyFill" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#f4a51c" stopOpacity=".18" /><stop offset="1" stopColor="#f4a51c" stopOpacity=".05" /></linearGradient>
              <linearGradient id="fieldFill" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#14b89a" stopOpacity=".46" /><stop offset="1" stopColor="#087c7b" stopOpacity=".2" /></linearGradient>
            </defs>
            <path className="landing-property-shape" d="M105,68 L484,45 L654,148 L614,380 L284,431 L83,306 Z" />
            <path className="landing-field-shape is-selected" d="M128,98 L331,78 L357,214 L176,236 L98,172 Z" />
            <path className="landing-field-shape" d="M343,79 L481,67 L615,151 L475,229 L360,211 Z" />
            <path className="landing-field-shape" d="M178,246 L357,222 L474,238 L433,397 L282,416 L111,302 Z" />
            <path className="landing-field-shape" d="M486,237 L611,168 L589,356 L448,395 Z" />
          </svg>
          <div className="landing-sensor-marker"><FaCloudSun /><i /></div>
          <div className="landing-field-popover">
            <span>Talhão selecionado</span><strong>Talhão Norte</strong>
            <div><em>Soja</em><em>42,8 ha</em><em>Plantio ativo</em></div>
          </div>
          <div className="landing-map-actions">
            <button><FaSatellite /> Imagens</button><button><FaClipboardCheck /> Nova ordem</button>
            <button><FaTint /> Irrigação</button><button><FaChartLine /> Talhão</button>
          </div>
        </div>
      </div>
    </div>
  );
}

function ModuleCard({ icon: Icon, title, description, tag }) {
  return (
    <article className="landing-module-card">
      <div className="landing-module-icon"><Icon /></div><span>{tag}</span><h3>{title}</h3><p>{description}</p><i aria-hidden="true"><FaArrowRight /></i>
    </article>
  );
}

function PlanCard({ plan, billing, onStart }) {
  const value = billing === 'annual' ? plan.annual / 12 : plan.monthly;
  const savings = getAnnualSavings(plan.id);
  return (
    <article className={`landing-plan-card${plan.recommended ? ' is-recommended' : ''}`}>
      {plan.recommended && <div className="landing-plan-ribbon">Recomendado</div>}
      <header><span>{plan.name}</span><p>{plan.description}</p></header>
      <div className="landing-plan-price">
        <strong>{formatCurrency(value)}</strong><small>/mês</small>
        {billing === 'annual' && <em>Cobrança anual de {formatCurrency(plan.annual)}</em>}
        {billing === 'annual' && savings > 0 && <em className="landing-plan-saving">Economize {formatCurrency(savings)} por ano</em>}
      </div>
      <button className={plan.recommended ? 'is-primary' : ''} onClick={onStart}>
        Testar grátis por 30 dias <FaArrowRight />
      </button>
      <ul>{(plan.features || []).map(feature => <li key={feature}><FaCheck /> <span>{feature}</span></li>)}</ul>
    </article>
  );
}

export default function LandingPage({ onEntrar, onCadastrar }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [billing, setBilling] = useState('monthly');

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 24);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const goTo = (id) => { setMenuOpen(false); scrollToSection(id); };
  const commercialPlans = ['essential', 'professional', 'management'].map(id => PAYMENT_CATALOG[id]);

  return (
    <div className="landing-page">
      <nav className={`landing-navbar${scrolled ? ' is-scrolled' : ''}`} aria-label="Navegação principal">
        <button className="landing-brand" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} aria-label="Ir para o início"><img src="/logo.png" alt="ClimoraX" /></button>
        <div className={`landing-nav-links${menuOpen ? ' is-open' : ''}`}>
          <button onClick={() => goTo('plataforma')}>Plataforma</button><button onClick={() => goTo('recursos')}>Recursos</button>
          <button onClick={() => goTo('seguranca')}>Segurança</button><button onClick={() => goTo('planos')}>Planos</button>
          <button className="landing-nav-login" onClick={onEntrar}>Entrar</button><button className="landing-nav-cta" onClick={onCadastrar}>Teste grátis <FaArrowRight /></button>
        </div>
        <button className="landing-menu-button" onClick={() => setMenuOpen(value => !value)} aria-label={menuOpen ? 'Fechar menu' : 'Abrir menu'} aria-expanded={menuOpen}>{menuOpen ? <FaTimes /> : <FaBars />}</button>
      </nav>

      <main>
        <section className="landing-hero">
          <div className="landing-hero-glow is-one" /><div className="landing-hero-glow is-two" />
          <div className="landing-container landing-hero-grid">
            <div className="landing-hero-copy">
              <div className="landing-eyebrow"><i /> Gestão agrícola conectada, do mapa ao campo</div>
              <h1>Toda a sua operação agrícola começa <span>no mapa.</span></h1>
              <p>Propriedades, talhões, plantios, clima, sensores, irrigação, tarefas e custos em uma única plataforma — com contexto para decidir e rastreabilidade para gerir.</p>
              <div className="landing-hero-actions">
                <button className="landing-button is-primary" onClick={onCadastrar}>Testar grátis por 30 dias <FaArrowRight /></button>
                <button className="landing-button is-secondary" onClick={() => goTo('plataforma')}>Conhecer a plataforma</button>
              </div>
              <div className="landing-hero-notes">
                <span><FaCheckCircle /> Acesso completo no período de teste</span><span><FaCheckCircle /> Sem cartão para começar</span><span><FaCheckCircle /> Funciona no celular e computador</span>
              </div>
            </div>
            <ProductPreview />
          </div>
        </section>

        <section className="landing-proof-strip" aria-label="Principais benefícios"><div className="landing-container">
          <span><FaMapMarkedAlt /> Gestão territorial</span><span><FaCloudSun /> Inteligência climática</span><span><FaMicrochip /> Sensores conectados</span><span><FaClipboardCheck /> Operação rastreável</span><span><FaChartLine /> Indicadores agrícolas</span>
        </div></section>

        <section id="plataforma" className="landing-section landing-platform-section"><div className="landing-container landing-platform-grid">
          <div className="landing-section-copy">
            <span className="landing-section-kicker">Central de Operações</span><h2>O mapa deixa de ser apenas uma imagem e passa a comandar a operação.</h2>
            <p>Selecione uma propriedade ou um talhão e acesse as ações daquele local: novo plantio, ordem de serviço, despesa, imagens, terreno, sensores e histórico.</p>
            <ul className="landing-check-list">
              <li><FaCheck /> Cadastro de propriedades e talhões diretamente no mapa</li><li><FaCheck /> Área calculada automaticamente pelo desenho</li>
              <li><FaCheck /> Polígonos, cultivos e atividades conectados entre os módulos</li><li><FaCheck /> Visualização por satélite com ferramentas de análise</li>
            </ul>
            <button className="landing-text-link" onClick={onCadastrar}>Experimentar a Central de Operações <FaArrowRight /></button>
          </div>
          <div className="landing-operation-flow">
            <div className="landing-flow-map"><span className="landing-flow-pin"><FaMapMarkedAlt /></span><svg viewBox="0 0 480 330" aria-hidden="true">
              <path className="flow-property" d="M51,91 L227,25 L422,78 L447,231 L299,303 L99,275 L32,180 Z" />
              <path className="flow-field one" d="M65,101 L220,44 L227,149 L93,178 L48,155 Z" /><path className="flow-field two" d="M237,42 L404,87 L417,156 L245,150 Z" />
              <path className="flow-field three" d="M99,190 L233,160 L282,285 L111,260 L49,187 Z" /><path className="flow-field four" d="M246,163 L419,168 L427,221 L297,286 Z" />
            </svg></div>
            <div className="landing-flow-cards">
              <div><FaSeedling /><span><small>Cultivo atual</small><strong>Soja · em desenvolvimento</strong></span></div>
              <div><FaClipboardCheck /><span><small>Execução</small><strong>Ordem programada para hoje</strong></span></div>
              <div><FaCloudSun /><span><small>Clima local</small><strong>Condição monitorada</strong></span></div>
            </div>
          </div>
        </div></section>

        <section id="recursos" className="landing-section landing-modules-section"><div className="landing-container">
          <div className="landing-section-heading"><span className="landing-section-kicker">Uma plataforma, vários módulos</span><h2>Informação organizada para quem está no campo e para quem faz a gestão.</h2><p>Os módulos conversam entre si para evitar retrabalho e manter cada registro associado à propriedade e ao talhão corretos.</p></div>
          <div className="landing-modules-grid">{productModules.map(module => <ModuleCard key={module.title} {...module} />)}</div>
        </div></section>

        <section className="landing-section landing-journey-section"><div className="landing-container">
          <div className="landing-section-heading is-left"><span className="landing-section-kicker">Do cadastro à decisão</span><h2>Uma rotina simples para uma operação mais profissional.</h2></div>
          <div className="landing-journey-grid">{journey.map((step, index) => <article key={step.number}>
            <span>{step.number}</span><div className="landing-journey-icon">{index === 0 ? <FaMapMarkedAlt /> : index === 1 ? <FaUsers /> : <FaChartLine />}</div><h3>{step.title}</h3><p>{step.description}</p>
          </article>)}</div>
        </div></section>

        <section id="seguranca" className="landing-section landing-trust-section"><div className="landing-container landing-trust-grid">
          <div className="landing-trust-copy"><span className="landing-section-kicker">Confiança para crescer</span><h2>Sua operação organizada com contexto, acesso e responsabilidade.</h2><p>O ClimoraX foi estruturado como uma plataforma SaaS: contas, propriedades, equipes e registros permanecem vinculados ao ambiente correto, com recursos liberados conforme o plano e o perfil do usuário.</p><div className="landing-trust-badge"><FaLock /> Ambiente protegido da sua conta</div></div>
          <div className="landing-trust-items">{trustItems.map(({ icon: Icon, title, text }) => <article key={title}><Icon /><div><h3>{title}</h3><p>{text}</p></div></article>)}</div>
        </div></section>

        <section id="planos" className="landing-section landing-plans-section"><div className="landing-container">
          <div className="landing-section-heading"><span className="landing-section-kicker">Planos do ClimoraX</span><h2>Comece completo. Escolha a escala que combina com sua operação.</h2><p>Todos começam com {TRIAL_PLAN.days} dias de acesso para conhecer a plataforma antes da contratação.</p></div>
          <div className="landing-trial-banner"><div className="landing-trial-icon"><FaRocket /></div><div><span>Teste gratuito</span><h3>{TRIAL_PLAN.days} dias com acesso completo ao ClimoraX</h3><p>Até {TRIAL_PLAN.limits.properties} propriedades, {TRIAL_PLAN.limits.fields} talhões, {TRIAL_PLAN.limits.sensors} sensores e {TRIAL_PLAN.limits.ndvi} processamentos NDVI durante a avaliação.</p></div><button onClick={onCadastrar}>Criar conta grátis <FaArrowRight /></button></div>
          <div className="landing-billing-toggle" aria-label="Periodicidade dos planos"><button className={billing === 'monthly' ? 'is-active' : ''} onClick={() => setBilling('monthly')}>Mensal</button><button className={billing === 'annual' ? 'is-active' : ''} onClick={() => setBilling('annual')}>Anual <span>economize</span></button></div>
          <div className="landing-plans-grid">{commercialPlans.map(plan => <PlanCard key={plan.id} plan={plan} billing={billing} onStart={onCadastrar} />)}</div>
          <p className="landing-price-note">Valores e limites exibidos conforme o catálogo comercial atual do ClimoraX.</p>
        </div></section>

        <section className="landing-final-cta"><div className="landing-container"><div><span>Pronto para organizar sua operação?</span><h2>Leve o mapa, o campo e a gestão para o mesmo lugar.</h2><p>Experimente o ClimoraX por 30 dias e conheça a plataforma completa.</p></div><div className="landing-final-actions"><button className="landing-button is-light" onClick={onCadastrar}>Começar agora <FaArrowRight /></button><button className="landing-button is-ghost" onClick={onEntrar}>Já tenho uma conta</button></div></div></section>
      </main>

      <footer className="landing-footer"><div className="landing-container landing-footer-grid">
        <div className="landing-footer-brand"><img src="/logo.png" alt="ClimoraX" /><p>Gestão agrícola conectada, do mapa ao campo.</p></div>
        <div><strong>Plataforma</strong><button onClick={() => goTo('plataforma')}>Central de Operações</button><button onClick={() => goTo('recursos')}>Recursos</button><button onClick={() => goTo('planos')}>Planos</button></div>
        <div><strong>Acesso</strong><button onClick={onEntrar}>Entrar</button><button onClick={onCadastrar}>Criar conta</button><a href="/politica-privacidade.html" target="_blank" rel="noreferrer">Privacidade</a></div>
        <div><strong>Contato</strong><a href={`mailto:${CONTACT_EMAIL}`}><FaEnvelope /> {CONTACT_EMAIL}</a><span>Atendimento digital</span></div>
      </div><div className="landing-container landing-footer-bottom"><span>© {new Date().getFullYear()} ClimoraX. Todos os direitos reservados.</span><span>Gestão Agrícola Inteligente</span></div></footer>
    </div>
  );
}
